import { Select, SelectProps } from 'antd';
import { platformLabelMap } from 'services/config/platform';
import toLowerCase from 'utils/toLowerCase';
import useStoreRegionOptions from '../hooks/useStoreRegionOptions';
import { useTranslate } from '@tolgee/react';

export default function PlatformSelect(props: SelectProps<General.PlatformUpperCase[]>) {
  const { t } = useTranslate();

  const { platforms, loading } = useStoreRegionOptions();

  const options = platforms.map((platform) => ({
    value: platform,
    label: platformLabelMap[toLowerCase(platform)] ?? platform,
  }));

  return (
    <Select
      dropdownMatchSelectWidth={false}
      mode="multiple"
      maxTagCount="responsive"
      loading={loading}
      options={options}
      placeholder={t('请选择')}
      style={{ width: '100%' }}
      {...props}
    />
  );
}
